import React from 'react';
import {
  CancelRounded,
  CheckCircleRounded,
  Edit,
  ErrorRounded,
  Stars
} from '@material-ui/icons';
import { Button, Modal } from 'react-bootstrap';
import './style.scss';

// Import custom SVG icons - place your SVG files in src/assets/icons/
// import { ReactComponent as StaticIcon } from '../../assets/icons/static-icon.svg';
// import { ReactComponent as AIIcon } from '../../assets/icons/ai-icon.svg';

// const DEFAULT_DUAL_CHOICE = {
//   left: {
//     title: 'Guided Chatbot',
//     description: 'Build and design your workflow manually using the editor.',
//     cta: 'Build Manually →',
//     icon: (
//       <StaticIcon className="icon-style" style={{ width: 30, height: 30 }} />
//     )
//   },
//   right: {
//     title: 'AI',
//     description:
//       'AI intelligently generates a complete workflow draft for you.',
//     cta: 'Build with AI →',
//     icon: <AIIcon className="icon-style" style={{ width: 26, height: 26 }} />
//   }
// };

const SweetAlert = ({
  show,
  handleClose,
  handleSubmit,
  type = 'success',
  heading = '',
  content,
  loading = false,
  closeBtn = true,
  saveBtn = false,
  secondarySaveBtn = false,
  secondarySaveBtnText = '',
  closeBtnText = 'Cancel',
  saveBtnText = 'Continue',
  handleSecondarySubmit,
  layoutVariant = null,
  dualChoice = null
}) => {
  const iconByType = {
    success: <CheckCircleRounded />,
    error: <CancelRounded />,
    warning: <ErrorRounded />
  };

  function mergeDualChoice(override) {
    if (!override || typeof override !== 'object') return dualChoice;
    return {
      left: { ...dualChoice.left, ...override.left },
      right: { ...dualChoice.right, ...override.right }
    };
  }

  const isDualChoice = layoutVariant === 'dualChoice';
  const choice = isDualChoice ? mergeDualChoice(dualChoice) : null;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size={isDualChoice ? 'lg' : 'md'}
      keyboard={false}
      backdrop={closeBtn === false ? 'static' : true}
      id="viewModal"
      dialogClassName={
        isDualChoice ? 'viewModal sweet-alert-modal--dual' : 'viewModal'
      }
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className={isDualChoice ? 'sweet-alert-body--dual p-0' : ''}>
        {isDualChoice ? (
          <div className="swal-dual-choice">
            <div className="swal-dual-choice__header">
              <div className="swal-dual-choice__hero-icon" aria-hidden>
                !
              </div>
              <h3
                className="swal-dual-choice__title"
                id="contained-modal-title-vcenter"
              >
                {heading}
              </h3>
              <p className="swal-dual-choice__lead">{content}</p>
            </div>
            <div className="swal-dual-choice__grid">
              <div className="swal-dual-choice__card swal-dual-choice__card--static">
                <div className="swal-dual-choice__card-icon-wrap swal-dual-choice__card-icon-wrap--static">
                  <span>
                    {choice.left.icon || (
                      <Edit style={{ fontSize: 18, color: 'var(--white)' }} />
                    )}
                  </span>
                </div>
                <h4 className="swal-dual-choice__card-title swal-dual-choice__card-title--static">
                  {choice.left.title}
                </h4>
                {choice.left.subtext && (
                  <p className="swal-dual-choice__card-subtext">
                    {choice.left.subtext}
                  </p>
                )}
                <p className="swal-dual-choice__card-desc">
                  {choice.left.description}
                </p>
                {choice.left.bullets?.length > 0 && (
                  <ul className="swal-dual-choice__card-bullets">
                    {choice.left.bullets.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
                <Button
                  type="button"
                  variant=""
                  className="swal-dual-choice__cta swal-dual-choice__cta--static btn-md mt-auto"
                  onClick={() =>
                    typeof handleSubmit === 'function' && handleSubmit()
                  }
                  disabled={loading || !saveBtn}
                >
                  {loading && saveBtn && (
                    <i className="uil uil-spinner spinner mr-1"></i>
                  )}
                  {choice.left.cta || saveBtnText}
                </Button>
              </div>
              <div className="swal-dual-choice__card swal-dual-choice__card--ai">
                <div className="swal-dual-choice__card-icon-wrap swal-dual-choice__card-icon-wrap--ai">
                  <span>
                    {choice.right.icon || (
                      <Stars
                        style={{ fontSize: 26, color: 'var(--primary-5)' }}
                      />
                    )}
                  </span>
                </div>
                <h4 className="swal-dual-choice__card-title swal-dual-choice__card-title--ai">
                  {choice.right.title}
                </h4>
                {choice.right.subtext && (
                  <p className="swal-dual-choice__card-subtext">
                    {choice.right.subtext}
                  </p>
                )}
                <p className="swal-dual-choice__card-desc">
                  {choice.right.description}
                </p>
                {choice.right.bullets?.length > 0 && (
                  <ul className="swal-dual-choice__card-bullets">
                    {choice.right.bullets.map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                )}
                <Button
                  type="button"
                  variant=""
                  className="swal-dual-choice__cta swal-dual-choice__cta--ai btn-md mt-auto"
                  onClick={() =>
                    typeof handleSecondarySubmit === 'function' &&
                    handleSecondarySubmit()
                  }
                  disabled={loading || !secondarySaveBtn}
                >
                  {loading && secondarySaveBtn && (
                    <i className="uil uil-spinner spinner mr-1"></i>
                  )}
                  {choice.right.cta || secondarySaveBtnText}
                </Button>
              </div>
            </div>
            {/* Cancel button for dual choice */}
            {closeBtn && (
              <div className="swal-dual-choice__footer text-center mt-3 pb-3 d-flex">
                <Button
                  variant="secondary"
                  className="btn-md ml-auto"
                  onClick={handleClose}
                >
                  {closeBtnText}
                </Button>
              </div>
            )}
          </div>
        ) : (
          <div className="swal-container">
            <div className="swal-icon">{iconByType[type]}</div>
            <div className="py-4">
              <h3 className="font-weight-bold">{heading}</h3>
              <p>{content}</p>
            </div>
            <div className="d-flex" style={{ gap: '10px' }}>
              {closeBtn && (
                <Button
                  variant={saveBtn ? 'secondary' : 'primary'}
                  className="btn-md px-5"
                  onClick={handleClose}
                  disabled={loading}
                >
                  {closeBtnText}
                </Button>
              )}
              {saveBtn && (
                <Button
                  variant="primary"
                  className="btn-md px-5"
                  onClick={() =>
                    typeof handleSubmit === 'function' && handleSubmit()
                  }
                  disabled={loading}
                >
                  {loading && <i className="uil uil-spinner spinner mr-1"></i>}
                  {saveBtnText}
                </Button>
              )}
              {secondarySaveBtn && (
                <Button
                  variant={saveBtn ? 'outline-primary' : 'primary'}
                  className="btn-md px-5"
                  onClick={() =>
                    typeof handleSecondarySubmit === 'function' &&
                    handleSecondarySubmit()
                  }
                  disabled={loading}
                >
                  {secondarySaveBtnText}
                </Button>
              )}
            </div>
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default SweetAlert;
